import { InputType, Locale } from 'src/types'

export function getFilterFields(
  locale: Locale['trackFuel']['historyFuel']['filters'],
) {
  const {
    fuelType,
    maxFuelPricePerLiter,
    maxFuelQuantity,
    minFuelPricePerLiter,
    maxOdometer,
    minFuelQuantity,
    maxTotalCost,
    minTotalCost,
    minOdometer,
  } = locale.input

  return [
    { key: 'minOdometer', type: InputType.NUMBER, placeholder: minOdometer },
    { key: 'maxOdometer', type: InputType.NUMBER, placeholder: maxOdometer },
    {
      key: 'minFuelQuantity',
      type: InputType.NUMBER,
      placeholder: minFuelQuantity,
    },
    {
      key: 'maxFuelQuantity',
      type: InputType.NUMBER,
      placeholder: maxFuelQuantity,
    },
    { key: 'fuelType', type: InputType.SELECT, placeholder: fuelType },
    {
      key: 'minFuelPricePerLiter',
      type: InputType.NUMBER,
      placeholder: minFuelPricePerLiter,
    },
    {
      key: 'maxFuelPricePerLiter',
      type: InputType.NUMBER,
      placeholder: maxFuelPricePerLiter,
    },
    { key: 'minTotalCost', type: InputType.NUMBER, placeholder: minTotalCost },
    { key: 'maxTotalCost', type: InputType.NUMBER, placeholder: maxTotalCost },
  ] as const
}
